export function percentileClassname(percentile?: number) {
  if (!percentile) {
    return "";
  }
  if (percentile <= 10) {
    return "bg-red-600 text-white font-semibold";
  }
  if (percentile <= 20) {
    return "bg-red-200 text-black/80 font-semibold";
  }
  if (percentile >= 90) {
    return "bg-green-600 text-white font-semibold";
  }
  if (percentile >= 80) {
    return "bg-green-200 text-black/80 font-semibold";
  }

  return "";
}
